export function parseHeaderToMarkdown(blocks) {
  switch (blocks.level) {
    case 1:
      return `h1. ${blocks.text}\n`;
    case 2:
      return `h2. ${blocks.text}\n`;
    case 3:
      return `h3. ${blocks.text}\n`;
    case 4:
      return `h4. ${blocks.text}\n`;
    case 5:
      return `h5. ${blocks.text}\n`;
    case 6:
      return `h6. ${blocks.text}\n`;
    default:
      break;
  }
}
